<div [class]="autoWidth ? 'table-responsive-auto' : 'table-responsive'">
  <table [class]="tableCss + (autoWidth ? ' table-auto-width' : '')">
    <thead class="table-light my-0 py-0">
      <tr class="my-0 py-0">
        @if (enableCheckbox) {
        <th class="checkbox-column-header sticky-column sticky-left my-0 py-0">
          <div class="checkbox-header-container">
            <input
              type="checkbox"
              class="checkbox-input"
              [checked]="isAllSelected()"
              [indeterminate]="isIndeterminate()"
              (change)="toggleAllRows($event)"
              [title]="isAllSelected() ? 'Tout désélectionner' : 'Tout sélectionner'"
            />
          </div>
        </th>
        }
        @for (column of columns; track column.header) {
        <th
          [class.sticky-column]="column.sticky"
          [class.sticky-left]="
            column.sticky && column.sticky.position === 'left'
          "
          [class.sticky-right]="
            column.sticky && column.sticky.position === 'right'
          "
          [style.width.px]="getColumnWidth(column)"
          [style.min-width.px]="getColumnWidth(column)"
          [style.max-width.px]="getColumnWidth(column)"
          [style.--column-width.px]="getColumnWidth(column)"
          [style.--sticky-left.px]="getStickyLeftPosition(column)"
          [style.--sticky-right.px]="getStickyRightPosition(column)"
          class="my-0 py-0"
        >
          <div class="column-header-container">
            <div class="column-header-content">
              @if (column.headerTemplate) {
              <div class="column-header-text-wrapper">
                <div class="column-header-template-wrapper">
              <ng-container
                [ngTemplateOutlet]="column.headerTemplate"
                [ngTemplateOutletContext]="{ $implicit: column }"
              ></ng-container>
                </div>
                @if (column.enableFilter && columnFilterTemplate) {
                <div class="column-filter-wrapper">
                  <ng-container
                    [ngTemplateOutlet]="columnFilterTemplate"
                    [ngTemplateOutletContext]="{ $implicit: column }"
                  ></ng-container>
                </div>
                }
              </div>
              } @else {
              <div class="column-header-text-wrapper">
                <span 
                  class="column-header-text" 
                  [title]="isHeaderTruncated(column.header) ? column.header : null"
                  [innerHTML]="getFormattedHeader(column.header)"
                ></span>
            @if (column.enableFilter && columnFilterTemplate) {
                <div class="column-filter-wrapper">
            <ng-container
              [ngTemplateOutlet]="columnFilterTemplate"
              [ngTemplateOutletContext]="{ $implicit: column }"
            ></ng-container>
                </div>
                }
              </div>
            }
            </div>
          </div>
        </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of data; track trackByRow($index, row)) {
      <tr>
        @if (enableCheckbox) {
        <td class="checkbox-column-cell sticky-column sticky-left" [style.padding]="cellPadding">
          <div class="checkbox-cell-container">
            <input
              type="checkbox"
              class="checkbox-input"
              [checked]="isRowSelected(row)"
              [attr.data-row-id]="getRowId(row)"
              (change)="toggleRowSelection(row, $event)"
            />
          </div>
        </td>
        }
        @for (column of columns; track column.field) {
        <td
          [class.sticky-column]="column.sticky"
          [class.sticky-left]="
            column.sticky && column.sticky.position === 'left'
          "
          [class.sticky-right]="
            column.sticky && column.sticky.position === 'right'
          "
          [style.width.px]="getColumnWidth(column)"
          [style.min-width.px]="getColumnWidth(column)"
          [style.max-width.px]="getColumnWidth(column)"
          [style.--column-width.px]="getColumnWidth(column)"
          [style.--sticky-left.px]="getStickyLeftPosition(column)"
          [style.--sticky-right.px]="getStickyRightPosition(column)"
          [style.padding]="cellPadding"
        >
          @if (column.cellTemplate) {
          <ng-container
            [ngTemplateOutlet]="column.cellTemplate"
            [ngTemplateOutletContext]="{ $implicit: row, column: column }"
          ></ng-container>
          } @else {
          {{ row[column.field] }}
          }
        </td>
        }
      </tr>
      }
    </tbody>
  </table>
</div>
